import React from "react";
import PropTypes from "prop-types";
import {
    withStyles,
    Button,
    Paper,
    Typography,
    IconButton,
    List,
    ListItem,
    Drawer,
    Divider,
    MenuItem,
    Select,
} from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import styles from "./styles";
import {translate} from "react-i18next";
import {compose} from "redux";


const Header = ({t, i18n, classes, adminScreen, activePage}) => {
    const [open, setOpen] = React.useState(false);

    const logoClick = () => {
        if (!(activePage === "home")) {
            window.location.replace("/");
        }
    };

    const toggleDrawer = open => event => {
        console.log("clicked")
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    const changeLanguage = event => {
        localStorage.setItem("Language", event.target.value);
        i18n.changeLanguage(event.target.value);
    };

    return (
        <div>
            <Paper className={classes.root} square>
                <img className={classes.logo} src={"../../Images/notariaat-elise-visser-logo.jpg"} alt={"Logo"} onClick={logoClick}/>
                {adminScreen ? (
                    <div className={classes.adminFormat}>
                        <Typography className={classes.adminText}>Admin onderhoud</Typography>
                    </div>
                ) : (
                    <div className={classes.navigationBar}>
                        <div className={classes.navigationBarBig}>
                            <Button className={classes.button}
                                    href={activePage === "home" ? "" : "/"}>{t("main:home")}</Button>
                            <Button className={classes.button}
                                    href={activePage === "about" ? "" : "/about"}>{t("main:who_are_we")}</Button>
                            <Button className={classes.button}
                                    href={activePage === "services" ? "" : "/services"}>{t("main:services")}</Button>
                            <Button className={classes.button}
                                    href={activePage === "contact" ? "" : "/contact"}>{t("main:contact")}</Button>
                        </div>
                        <div className={classes.languageSelector}>
                            <Select
                                value={i18n.language}
                                onChange={changeLanguage}
                                displayEmpty
                                name="Language"
                                className={classes.selector}
                            >
                                <MenuItem value={"nl"}>NL</MenuItem>
                                <MenuItem value={"en"}>EN</MenuItem>
                            </Select>
                        </div>
                        <div className={classes.navigationBarSmall}>
                            <IconButton color="inherit" onClick={toggleDrawer(true)}>
                                <MenuIcon/>
                            </IconButton>
                        </div>
                    </div>
                )}
            </Paper>
            <Drawer className={classes.drawer} anchor={"right"} open={open}
                    onClose={toggleDrawer(false)}>
                <div
                    className={classes.list}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <List>
                        <Divider/>
                        <ListItem component={Button} className={classes.button} href={activePage === "home" ? "" : "/"}>
                            {t("main:home")}
                        </ListItem>
                        <Divider/>
                        <ListItem component={Button} className={classes.button}
                                  href={activePage === "about" ? "" : "/about"}>
                            {t("main:who_are_we")}
                        </ListItem>
                        <Divider/>
                        <ListItem component={Button} className={classes.button}
                                  href={activePage === "services" ? "" : "/services"}>
                            {t("main:services")}
                        </ListItem>
                        <Divider/>
                        <ListItem component={Button} className={classes.button}
                                  href={activePage === "contact" ? "" : "/contact"}>
                            {t("main:contact")}
                        </ListItem>
                        <Divider/>
                    </List>
                </div>
            </Drawer>
        </div>
    )
};

export default compose(
    translate(),
    withStyles(styles)
)(Header)

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    adminScreen: PropTypes.bool,
    activePage: PropTypes.string,
};

Header.defaultProps = {
    adminScreen: false,
    activePage: "",
};